import cleanUpResponse from "@/util/cleanUpResponse";

export default async function SaveCustomerOrder(orderId, serialFormData) {
    const response = await $.soap({
        body: {
            SaveCustomerOrderAttachments: {
                $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
                OrderID: orderId,
                FundingTypeID: serialFormData.fundingTypeID,
                NoFundingExplanation: serialFormData.noFundingExplanation,
                GInvoicingOrderNumber: serialFormData.gInvoicingOrderNumber,
                FundingAmount: serialFormData.fundingAmount,
                AdditionalDocumentsRequired: serialFormData.additionalDocumentsRequired
            }
        },
    });

    cleanUpResponse(response);
    return response.editedId
}